// extracted by mini-css-extract-plugin
export default {"wrapper":"VFContainerWrapper_wrapper__htmLM","header":"VFContainerWrapper_header__B4hxr","title":"VFContainerWrapper_title__xLToH"};